import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-grow-1" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "symbol symbol-100px symbol-fixed position-relative" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px" }, null, -1)
const _hoisted_8 = { class: "flex-grow-1" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "d-flex align-items-center mb-2" }
const _hoisted_12 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_13 = { href: "#" }
const _hoisted_14 = { class: "svg-icon svg-icon-1 svg-icon-success" }
const _hoisted_15 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_16 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_17 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_18 = { class: "flex-grow-1" }
const _hoisted_19 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_20 = { class: "d-flex align-items-center text-hover-primary me-5 mb-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold d-block" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-envelope mr-2" })
], -1)
const _hoisted_22 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_23 = { class: "d-flex align-items-center text-hover-primary me-5 mb-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold d-block" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-phone mr-2" })
], -1)
const _hoisted_25 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_26 = { class: "d-flex align-items-center text-hover-primary me-5 mb-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold d-block" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-address-card mr-2" })
], -1)
const _hoisted_28 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_29 = { class: "card-header cursor-pointer bg-success" }
const _hoisted_30 = { class: "card-title m-0" }
const _hoisted_31 = { class: "fw-bolder m-0 text-light" }
const _hoisted_32 = { class: "card-body pt-9 pb-0" }
const _hoisted_33 = { class: "row mb-7" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Name", -1)
const _hoisted_35 = { class: "col-lg-8" }
const _hoisted_36 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_37 = { class: "row mb-7" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Date Of Birth ", -1)
const _hoisted_39 = { class: "col-lg-8 fv-row" }
const _hoisted_40 = { class: "fw-bold fs-6" }
const _hoisted_41 = { class: "row mb-7" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "NID", -1)
const _hoisted_43 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_44 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-success" }, "Verified", -1)
const _hoisted_46 = { class: "row mb-7" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Passport", -1)
const _hoisted_48 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_49 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_50 = { class: "row mb-7" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Driving License", -1)
const _hoisted_52 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_53 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_54 = { class: "row mb-7" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Gender", -1)
const _hoisted_56 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_57 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_58 = { class: "row mb-7" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Religion", -1)
const _hoisted_60 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_61 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_62 = { class: "row mb-7" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Present Address", -1)
const _hoisted_64 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_65 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_66 = { class: "row mb-7" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Parmanent Address", -1)
const _hoisted_68 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_69 = { class: "fw-bolder fs-6 me-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: 
                this.employee?.attach_file_info?.file_path
                  ? _ctx.api_url + this.employee?.attach_file_info?.file_path
                  : 'media/avatars/blank.png'
              
              }, null, 8, _hoisted_6),
              _hoisted_7
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("a", _hoisted_12, _toDisplayString(this.employee?.name), 1),
                  _createElementVNode("a", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen026.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("a", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com006.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(this.userInfo?.employee?.designation
                      ? this.userInfo?.employee?.designation
                      :  this.userInfo?.employee?.entity_organogram[0]?.entitytyperole
                        ?.role_title), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createTextVNode("Email : " + _toDisplayString(this.employee?.email), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createTextVNode("Contact :" + _toDisplayString(this.employee?.mobile), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createTextVNode(" Present Address :" + _toDisplayString(this.employee?.present_address), 1)
              ])
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("h3", _hoisted_31, " Profile Details " + _toDisplayString(this.employee.name), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("span", _hoisted_36, _toDisplayString(this.employee?.name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("span", _hoisted_40, _toDisplayString(this.employee?.dob), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("span", _hoisted_44, _toDisplayString(this.employee?.nid), 1),
            _hoisted_45
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("span", _hoisted_49, _toDisplayString(this.employee?.passport), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _hoisted_51,
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("span", _hoisted_53, _toDisplayString(this.employee?.driving_license), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _hoisted_55,
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("span", _hoisted_57, _toDisplayString(this.employee?.gender), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _hoisted_59,
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("span", _hoisted_61, _toDisplayString(this.employee?.religion), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _hoisted_63,
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("span", _hoisted_65, _toDisplayString(this.employee?.present_address), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_66, [
          _hoisted_67,
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("span", _hoisted_69, _toDisplayString(this.employee?.permanent_address), 1)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ])
  ], 64))
}